<template>
    <section class="content-subject">
        <template v-if="container">
            <div :class="{fluid: isFluid, 'content-wrapper-subject': !classic, 'content-wrapper-simple': classic}">
                <slot></slot>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </section>
</template>

<script>
    export default {
        name: "ContentBlock",
        props: {
            fluid: {type: Boolean, default: false},
            container: {
                type: [Boolean, String],
                default: false
            },
            classic: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isFluid() {
                return (this.$props.fluid && this.$sidebar.instance.$data.minimize) && !this.$props.classic
            }
        }
    }
</script>